<!-- filepath: d:\programming\vuejs-components\Vc Website Components\src\components\modalwrappers\ApiQueryModal.vue -->
<template>
  <!-- Vue-controlled API Query Modal -->
  <template v-if="show">
    <div class="modal-backdrop fade show" @click="$emit('close')"></div>
    
    <div class="modal fade show" 
         style="display: block;" 
         tabindex="-1" 
         aria-labelledby="apiQueryModalLabel" 
         aria-modal="true"
         @keydown.esc="$emit('close')">
      
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="apiQueryModalLabel">Weather API Queries</h5>
            <button type="button" class="btn-close" @click="$emit('close')" aria-label="Close"></button>
          </div>
          
          <form @submit.prevent>
            <div class="modal-body">
              <p>
                This page is populated using the <a href="/weather-api">Visual Crossing Weather API</a> using the following query. 
                To build Weather API queries for yourself, head over to our <a href="/weather-query-builder">Weather Query Builder</a> page. 
                Also see our <a href="/resources/documentation/weather-api/timeline-weather-api/">API docs</a>
              </p>

              <div v-if="queryDefinitions && queryDefinitions.length > 1" class="d-flex mt-3 align-items-center">
                <div class="fw-bold">Available queries</div>
                
                <!-- Vue-controlled dropdown -->
                <div class="dropdown" ref="dropdownRef">
                  <button class="dropdown-toggle btn text-primary px-1" 
                          type="button" 
                          @click.stop="showDropdown = !showDropdown"
                          :aria-expanded="showDropdown">
                    {{ selectedQueryDefnLabel }}
                  </button>
                  <ul class="dropdown-menu" :class="{ show: showDropdown }">
                    <li v-for="queryDef in queryDefinitions" 
                        :key="queryDef.id"
                        @click="selectQueryDefinition(queryDef)">
                      <a class="dropdown-item" href="#" @click.prevent v-html="queryDef.id"></a>
                    </li>
                  </ul>
                </div>
              </div>
              
              <ApiQuery v-if="selectedQueryDefn" 
                        :sessionState="sessionState" 
                        :queryDefinition="selectedQueryDefn" />
              <div v-else>Please select a query definition</div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import ApiQuery from '/src/components/ApiQuery.vue';

export default {
  name: 'ApiQueryModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    queryDefinitions: {
      type: Array,
      default: () => []
    },
    selectedQueryDefn: {
      type: Object,
      default: null
    },
    sessionState: {
      type: Object,
      default: null
    }
  },
  emits: ['close', 'select-query-definition'],
  data() {
    return {
      showDropdown: false
    }
  },
  computed: {
    selectedQueryDefnLabel() {
      if (this.selectedQueryDefn) {
        return this.selectedQueryDefn.id;
      }
      return '-';
    }
  },
  methods: {
    selectQueryDefinition(queryDef) {
      this.showDropdown = false;
      this.$emit('select-query-definition', queryDef);
    },

    // Handle clicks outside dropdown
    handleClickOutside(event) {
      // Check if the dropdown ref exists and if the click is outside
      if (this.$refs.dropdownRef && !this.$refs.dropdownRef.contains(event.target)) {
        this.showDropdown = false;
      }
    },

    // Handle ESC key
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        if (this.showDropdown) {
          this.showDropdown = false;
        } else {
          this.$emit('close');
        }
      }
    }
  },
  watch: {
    // Add/remove event listeners based on show prop
    show: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            document.addEventListener('click', this.handleClickOutside);
            document.addEventListener('keydown', this.handleKeyDown);
          });
        } else {
          document.removeEventListener('click', this.handleClickOutside);
          document.removeEventListener('keydown', this.handleKeyDown);
        }
      }
    }
  },
  beforeUnmount() {
    // Clean up event listeners
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeyDown);
  },
  components: {
    ApiQuery
  }
}
</script>

<style scoped>
/* Ensure proper z-index layering */
.modal-backdrop {
  z-index: 1040;
}

.modal {
  z-index: 1050;
}

/* Dropdown styles */
.dropdown-menu.show {
  display: block;
}
</style>